import { render, staticRenderFns } from "./PuestoDependenciaComponent.vue?vue&type=template&id=9a8a1ce6"
import script from "./PuestoDependenciaComponent.vue?vue&type=script&lang=js"
export * from "./PuestoDependenciaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports